import { render } from "./WorkstationVerificationModal.vue?vue&type=template&id=3c5698bf&scoped=true&ts=true"
import script from "./WorkstationVerificationModal.vue?vue&type=script&lang=ts"
export * from "./WorkstationVerificationModal.vue?vue&type=script&lang=ts"

import "./WorkstationVerificationModal.vue?vue&type=style&index=0&id=3c5698bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5698bf"]])

export default __exports__